// Central place for site copy/contact details — easy for the owner to edit later.
export const SITE = {
  business: "The Patient Tech Bloke",
  tagline: "Patient, friendly IT help for seniors — at your kitchen table.",
  phone: "0404 744 278",
  phoneTel: "+61404744278",
  email: "help@thepatienttechbloke.com.au",
  area: "Servicing Adelaide & surrounds",
  hours: "Mon – Sat, 9am – 6pm",
  ownerName: "Tom",
  ownerPhoto: "https://customer-assets.emergentagent.com/job_patient-tech-help/artifacts/gx0lq59z_face.jpg",
  logo: "https://customer-assets.emergentagent.com/job_patient-tech-help/artifacts/6nrp5oud_image.png",
  yearsExperience: 25,
};
